import adminApiClient from '../api/adminApiClient'
import type { Locale, Role } from '../types'

export async function getLocales(): Promise<Locale[]> {
  const { data } = await adminApiClient.get<Locale[]>('/locales')
  return data
}

export async function getRoles(): Promise<Role[]> {
  const { data } = await adminApiClient.get<Role[]>('/roles')
  return data
}
